import { defineStyle as o, defineStyleConfig as e } from "@chakra-ui/react";
const l = o({
  display: "inline-block",
  width: "100%",
  height: "auto",
  ".cls-1": {
    color: "gray.700",
    fill: "currentColor"
  }
}), i = e({
  baseStyle: l
});
export {
  i as default
};
